import { MobileMenuDialogProps } from '@/types/props/components/layout';
import { Fragment, useState } from 'react';
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import clsx from 'clsx';
import { ImagesHeaderCloseSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import Image from 'next/image';
import MobileMenuDialogMenu from './MobileMenuDialogMenu';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import ContactFormV2 from '@/components/common/ContactForm/ContactFormV2';

export default function MobileMenuDialog({
  open,
  onClose,
  currentSubMenuActive,
  setCurrentSubMenuActive,
}: MobileMenuDialogProps) {
  const { translate } = useTypedTranslation<HeaderEnum>('header');
  const [contactFormOpen, setContactFormOpen] = useState(false);

  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          className="tw-relative tw-z-[9999] max-nine:tw-p-2"
          onClose={() => onClose()}
        >
          <div className="tw-fixed tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center">
            <TransitionChild
              as={Fragment}
              enter="tw-ease-out tw-duration-300"
              enterFrom="tw-opacity-0 tw-scale-95"
              enterTo="tw-opacity-100 tw-scale-100"
              leave="tw-ease-in tw-duration-200"
              leaveFrom="tw-opacity-100 tw-scale-100"
              leaveTo="tw-opacity-0 tw-scale-95"
            >
              <DialogPanel
                className={clsx(
                  'tw-min-h-screen tw-bg-white tw-w-screen tw-px-3 tw-py-7'
                )}
              >
                <div className="tw-h-screen tw-overflow-y-scroll tw-px-3">
                  <div className="tw-sticky tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-platinum-gray tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-pb-4 tw-py-2 tw-bg-white">
                    <DefaultButton
                      aria-label="Close menu"
                      onClick={() => onClose()}
                      className="tw-absolute tw-left-0 tw--translate-y-1/2 tw-top-5"
                    >
                      <Image
                        src={ImagesHeaderCloseSvg}
                        alt="close"
                        width={24}
                        height={24}
                      />
                    </DefaultButton>

                    <p className="tw-p-0 tw-m-0 tw-font-plusJakartaSans tw-font-semibold tw-leading-[20.16px] tw-text-base tw-text-center tw-text-textBlack">
                      {translate(HeaderEnum['common.menu'])}
                    </p>
                  </div>
                  <div>
                    <MobileMenuDialogMenu
                      currentSubMenuActive={currentSubMenuActive}
                      setCurrentSubMenuActive={setCurrentSubMenuActive}
                      onClose={onClose}
                      setContactFormOpen={setContactFormOpen}
                    />
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition>

      <ContactFormV2
        isOpen={contactFormOpen}
        onClose={() => setContactFormOpen(false)}
      />
    </>
  );
}
